// Configuration for the phishing report add-in (values from .env at build time via webpack DefinePlugin)
export const config = {
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL,

  MSAL_COMMANDS: {
    auth: {
      clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
      authority: process.env.REACT_APP_MSAL_AUTHORITY,
    },
  },

  // Default settings
  DEFAULTS: {
    forwardTo: "security@company.com",
    targetFolder: "quarantine",
    maxActionLogs: 10,
  },

  // UI Configuration
  UI: {
    // Placeholder texts
    placeholders: {
      forwardEmail: "security@company.com",
      endpointUrl: "https://api.example.com/webhook",
      emailSubject: "subject here...",
      emailBody: "Additional body here...",
    },

    // Error messages
    messages: {
      accessDenied:
        "You are not authorized to access this. Please contact your administrator to request access.",
     initializationFailed: "Failed to initialize app",
      settingsSaveSuccess: "User settings saved successfully",
      forwardEmailRequired: "Forward email address is required",
      forwardEmailRequiredMessage: "Forward email address is required to save settings",
    },
  },

  // API Endpoints
  ENDPOINTS: {
    CHECK_PERMISSION: "/api/auth/checkPermission",
  },
};

export default config;
